import { Directive } from '@angular/core';

@Directive({ standalone: false,
  selector: '[docSelectInput]'
})
export class SelectInputDirective {

  constructor() { }

}
